module.exports = __webpack_public_path__ + "assets/media/level4-user-icon.85ef155d.png";